<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <el-upload
      class="upload-demo"
      :action="uploadurl"
      multiple
      :limit="3"
      :file-list="fileList"
      :on-preview="onPreview"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :on-success="afterUpload"
    >
      <el-button size="small" type="primary" >Click to upload</el-button>
      <div slot="tip" class="el-upload__tip">jpg/jpeg/png/pdf/docx/xls/xlsx/csv files</div>
    </el-upload>
  </div>
</template>

<script>
import swal from "sweetalert2";
import FileInput from "@/components/Inputs/FileInput";
import { Progress, Upload, Button } from "element-ui";
import { uploadUrl, fileUrl } from "../../services/helper";
import { GenerateHex } from "../../services/crypto";
import { Create, GetFiles, Delete } from "../../services/files";
import { FileType } from "../../services/types";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "upload",
  components: {
    [Progress.name]: Progress,
    [Upload.name]: Upload,
    [Button.name]: Button,
    FileInput,
    Loading
  },
  computed: {
    uploadurl() {
      return uploadUrl;
    },
    fileurl() {
      return fileUrl;
    }
  },
  props: {
    sourcetype: Number,
    sourceId: String,
    sourcedetId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      progress: 0,
      fileList: [],
      isLoading: false
    };
  },
  methods: {
    beforeRemove(file, fileList) {
      this.isLoading = true;
      Delete(file.id).then(response => {
        this.isLoading = false;
        if (response.data.result) {
          this.getFiles();
        } else {
          this.notifyVue("danger", response.data);
        }
      });
    },
    onPreview(file) {
      const path = this.fileurl + file.year + "/" + file.rawname;
      window.open(path, "_blank");
    },
    beforeUpload(file) {
      
      let fname = file.name;
      let key = GenerateHex();
      let newname = key + "_" + fname;
      Object.defineProperty(file, "name", {
        writable: true,
        value: newname
      });
    },

    afterUpload(response, file, fileList) {
      if (!response.result) return;

      var f = new FileType();
      f.filename = file.raw.name;
      f.sourcetype = this.sourcetype;
      f.sourceId = this.sourceId;
      f.sourcedetId = this.sourcedetId;
      this.isLoading = true;
      Create(f).then(response => {
        this.isLoading = false;
        if (response.data) {
          this.getFiles();
          
        }
      });
    },
    getFiles() {
      this.isLoading = true;
      GetFiles(this.sourcetype, this.sourceId, this.sourcedetId).then(
        response => {
          this.fillList(response.data.result);
          this.isLoading = false;
        }
      );
    },
    fillList(files) {
      this.fileList = [];
      if (files === undefined) return;
      for (let i = 0; i < files.length; i++) {
        let fname = files[i].filename.substring(
          files[i].filename.indexOf("_") + 1
        );
        this.fileList.push({
          name: fname,
          year: files[i].year,
          id: files[i].id,
          rawname: files[i].filename
        });
      }
    }
  },
  watch: {
    sourceId: function() {
      this.getFiles();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>